import React from "react";
// import FormProgress from "../UnitAdmin/FormProgress";
import FormProgress from "../AuditAdmin/FormProgress";
import SendBackAddendumAccordion from "./SendBackAddendumAccordion";
import "./protocol.scss";

const SendBackAddendum = ({version}) => {
  return (
    <>
      <div className="addendum-main-container">
        <FormProgress />
        <div className="addendum-heading">Mars QMS - QMS Addendum</div>
        <SendBackAddendumAccordion version={version}/>
      </div>

      {/* <div id="action-button-container">
        <>
          {!saveButtonLoading ? (
            <button
              // disabled={saveButtonLoading}
              onClick={() => saveFormData()}
              className="action-btn"
            >
              Save
            </button>
          ) : (
            <button
              // disabled={saveButtonLoading}
              // onClick={() => saveFormData()}
              className="action-btn"
            >
              Loading...
            </button>
          )}
        </>
        <>
          {!submitButtonLoading ? (
            <button
              // disabled={newValue}
              onClick={() => setOpenPopup(true)}
              className="action-btn"
            >
              Submit
            </button>
          ) : (
            <button
              // disabled={buttonsDisable}
              // onClick={() => setOpenPopup(true)}
              className="action-btn"
            >
              Loading...
            </button>
          )}
        </>
      </div> */}
    </>
  );
};

export default SendBackAddendum;
